import type { InjectionKey } from 'vue';

export const createInjectionContext = <T>(name: string) => {
  const key: InjectionKey<T> = Symbol(name);

  const provideContext = (value: T) => {
    provide(key, value);
    return value;
  };

  const useContext = (): T | null => {
    return inject(key, null) as T | null;
  };

  return { provideContext, useContext };
};
